import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useFetch } from '@/modules/core/composables/useFetch'

interface TaxEngagementStatus {
  tax_year: number
  engaged: boolean
  agreed: boolean
  agreed_by: string | null
  agreed_at: string | null
}

export const useGroupTaxStore = defineStore('GroupTax', () => {
  const route = useRoute()
  const baseUrl = computed(() => `/v4/${route.params.slug}/tax/engagement-agreements`)

  const taxEngagementStatus = ref<TaxEngagementStatus>({
    tax_year: new Date().getFullYear() - 1,
    engaged: false,
    agreed: false,
    agreed_by: null,
    agreed_at: null,
  })
  const isLoading = ref(false)
  const hasFetched = ref(false)
  const fetchError = ref(false)

  const fetchTaxEngagementStatus = async () => {
    isLoading.value = true
    fetchError.value = false
    try {
      const data = await useFetch(`${baseUrl.value}/status`).get<TaxEngagementStatus>()
      taxEngagementStatus.value = data
    } catch (err) {
      console.error('Failed to fetch tax engagement status:', err)
      fetchError.value = true
    } finally {
      isLoading.value = false
      hasFetched.value = true
    }
  }

  const agreeToTaxEngagement = async () => {
    isLoading.value = true
    try {
      await useFetch(`${baseUrl.value}/agree`).post()
      await fetchTaxEngagementStatus()
      return true
    } catch (err) {
      console.error('Failed to agree to tax engagement:', err)
      throw err
    } finally {
      isLoading.value = false
    }
  }

  return {
    taxEngagementStatus,
    isLoading,
    hasFetched,
    fetchError,
    fetchTaxEngagementStatus,
    agreeToTaxEngagement,
  }
})
